import { NgModule } from '@angular/core';
import { NewRadioComponent } from './radio.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [NewRadioComponent],
  imports: [CommonModule],
  exports: [NewRadioComponent],
})
export class NewRadioComponentModule {}
